import { isTrainingHost, systemOrigin } from './system-origin.js';
import { N9_SYSTEM_URL } from './n9-attribution.js';

export const OFFICIAL_SITE_URL = isTrainingHost() ? `${systemOrigin('workspace')}/guide` : N9_SYSTEM_URL;
export const WORKSPACE_LOGIN_ORIGIN = systemOrigin('workspace');
export const REPORTS_LOGIN_ORIGIN = systemOrigin('reports');
export const TRAINING_GUIDE_URL = 'https://n9-training.n9-law-system.workers.dev/guide';

export function workspaceLoginPath(slug) {
  return /^[a-z][a-z0-9-]{2,47}$/.test(slug || '') ? `/office/${slug}` : '/login';
}

export function officeLoginLink(slug, system = 'workspace') {
  if (!/^[a-z][a-z0-9-]{2,47}$/.test(slug || '')) return '';
  if (system === 'workspace') return `${WORKSPACE_LOGIN_ORIGIN}/office/${slug}`;
  if (system === 'reports') return `${REPORTS_LOGIN_ORIGIN}/?office=${slug}&entry=portal`;
  return '';
}

export function returnToOfficialSite(location = window.location) {
  location.replace(OFFICIAL_SITE_URL);
}

export async function confirmedLogout(revoke, location = window.location, workspaceEntry = null) {
  try { await revoke(); }
  catch (error) {
    if (error.status !== 401 && error.code !== 'UNAUTHENTICATED') throw error;
  }
  location.replace(workspaceEntry ? workspaceLoginPath(workspaceEntry.officeSlug) : OFFICIAL_SITE_URL);
}
